// @flow
import React, { Component, useState, useEffect } from 'react'
import Tabletop from 'tabletop'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import Masthead from '@ta-interaktiv/react-masthead'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'


import Scrollchor from 'react-scrollchor'
import Footer from '@ta-interaktiv/react-footer'
import {Category} from '../category'
declare global {
  interface Window {
    dataLayer: []
  }
}

interface CategoryInformation {
  Spaltenname: string
  Header: string
  Subheader: string
}
interface sheetProperty {
  columnNames: string[]
  column_names: string[]
  elements: {
    hintergründe: string
    meinungen: string
    visuell: string
  }[]
  name: string
  onReady: () => {}
  originalColumns: string[]
  original_columns: string[]
  prettyColumns: { [key: string]: string }
  pretty_columns: { [key: string]: string }
  raw: { encoding: string; feed: { [key: string]: any }; version: string }
  tabletop: { [key: string]: any }
}
interface sheetData {
  Artikel: sheetProperty
  Kategorien: sheetProperty
}
interface appProps {}
interface appState {
  cards: []
  cardsShared: []
  cardsCommented: []
  listOfArticles: []
  categoryMap?: Map<string, CategoryInformation>
  articleIDList?: Map<string, string[]>
  time: string
  request: string
}

window.dataLayer = window.dataLayer || []
const SPREADSHEET_KEY='1qGVl6ALwG0L7M4dvp-oJ3wfA-U0cRPAu282OI4p4BLg'
const ARTICLE_ID = '23014986'


class AppComponent extends Component<appProps, appState> {
  constructor(props: {}) {
    super(props)

    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)

    this.state = {
      cards: [],
      cardsShared: [],
      cardsCommented: [],
      listOfArticles: [],
      time: '',
      request: 'loading'
    }
  }

  trackNavClicks(e) {
    let clickedText = e.currentTarget.parentNode.getAttribute('href')
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'category: ' + clickedText
    })
  }

  trackTopClicks(e) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: '
    })
  }

  linkClick(e) {
    let currentLink = e.currentTarget.getAttribute('data-link')
    let currentCategory = e.currentTarget.getAttribute('data-category')

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: currentCategory + ': ' + currentLink
    })
  }

  componentDidMount() {
    Tabletop.init({
      key:
        'https://docs.google.com/spreadsheets/d/'+SPREADSHEET_KEY+'/edit?usp=sharing',
        // 'https://docs.google.com/spreadsheets/d/1FSp_Y2UwznD0uLeqCHWMG-aA15olZwiqMtDbJcj1v9Q/edit?usp=sharing',
      simpleSheet: false,
      callback: (data: sheetData) => {
        console.group("DATA")
        console.log('DATA-IN', data)
        // Gather all categories that have been set up in the sheet
        const categories: Array<CategoryInformation> =
          data['Kategorien'].elements
        const articleRows: Array<{ [key: string]: string }> =
          data['Artikel'].elements
        const articleIDList: Map<string, string[]> = new Map()
        const categoryMap: Map<string, CategoryInformation> = new Map()

        categories.forEach(cat => {
          const articleIDs: string[] = []
          articleRows.forEach(articleRow => {
            // Test for
            // does a property with that property name exist
            // is it not an empty string
            // does it have the form of an article ID (as in: 8 digits)
            if (
              articleRow[cat.Spaltenname] !== '' &&
              /\d{8}/.test(articleRow[cat.Spaltenname])
            ) {
              articleIDs.push(articleRow[cat.Spaltenname])
            }
          })
          articleIDList.set(cat.Spaltenname, articleIDs)
          categoryMap.set(cat.Spaltenname, cat)
        })


        this.setState({
          categoryMap,
          articleIDList,
          request: 'success'
        })
        console.log('state', this.state)

        console.groupEnd()
      }
    })
  }

  getTime = () => {
    return (
      <div>
        <p className='time'>
          <span className='update'>Letztes Update</span>: {this.state.time} Uhr.
        </p>
      </div>
    )
  }

  onEnter = id => {
    console.log('ID', id)
    console.log('onEnter function')
    window.header.setHeaderId(id)
  }

  render() {
    console.log('STATE', this.state)
    // Populate the categories
    const categories: {}[] = []
    if (this.state.articleIDList) {
      this.state.articleIDList.forEach((value, key) => {
        if (value.length > 0) {
          categories.push(
            <Category
              key={key}
              categorySlug={key}
              categoryHeader={this.state.categoryMap.get(key).Header}
              categorySubHeader={this.state.categoryMap.get(key).Subheader}
              articleIDs={value}
              clickHandler={this.linkClick}
            />
          )
        }
      })
    }

    const menu = []
    if (this.state.categoryMap) {
      this.state.categoryMap.forEach((val, key) => {
        const numberArticles = this.state.articleIDList.get(key).length
        menu.push(
          <Scrollchor to={'#' + key} key={key}>
            <div className='question-container' onClick={this.trackNavClicks}>
              <li className='question-link'>
                {val.Header}
                <span className='numberArticles' />
              </li>
              <i className='chevron down icon' />
            </div>
          </Scrollchor>
        )
      })
    }

    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead articleId={ARTICLE_ID} />

        <header className='ui vertical segment headerSegment'>
          <div className='ui text container intro'>
            <div className='intro'>
              <h2 className=''>
                <img
                  src={require('./energie.svg')}
                  alt='Im Treibhaus'
                  className={'ui large centered image'}
                />
              </h2>
              <h2 className='introTitleTwo'>
                Die besten Hintergründe, Analysen und Grafiken zum Thema Energie
              </h2>
            </div>

            <div
              className={`ui ${
                this.state.request
              } ui text container segment menu`}
            >
              <ul className='nav' id='nav'>
                {menu}
              </ul>
            </div>
            <div
              className='ui text container infographic mobile hidden'
              style={{ paddingTop: '2em' }}
            >
              <FeedbackMessage />
            </div>
          </div>
        </header>

        <div
          className={`ui ${
            this.state.request
          } vertical segment grey articleSegment`}
        >
          {categories}

          <div className='ui container end' />

          {/* footer */}
          <Footer
            articleId={ARTICLE_ID}
            credits={[
              [
                'Digitale Umsetzung',
                'Patrick Vögeli und Kaspar Manz, Interaktiv-Team'
              ]
            ]}
            hideUserFeedback={true}
            hidePortfolioTeaser={true}
          />
        </div>
      </div>
    )
  }
}



export default hot(module)(AppComponent)
